module.exports = __webpack_public_path__ + "static/media/Chinchou_gaussian2.e681c900.png";